// @flow
import { connect } from 'react-redux'
import KeywordsTextArea from './KeywordsTextArea'
import type { Store } from '../../redux/ducks'
import { patch } from '../AudienceEditContainer'
import type { GroupedStringParameters } from '../types'
import * as segmentationReducer from '../../redux/ducks/segmentation/reducers'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit

  return {
    errors: audienceState.keywordsErrors,
    keywordsGroups: audienceState.keywordsGroups
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onKeywordGroupAdd: () => {
      dispatch(segmentationReducer.patch({ segmentByKeywords: true }))
      patch(dispatch, { useKeywordsGroupNames: true })
    },
    onKeywordGroupRemove: (groups: Array<GroupedStringParameters>) => {
      patch(dispatch, { useKeywordsGroupNames: groups.length > 1 })
    }
  }
}

const KeywordsTextAreaContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(KeywordsTextArea)

export default KeywordsTextAreaContainer
